import { createSvgComponent } from "../../icon/createSvgComponent";
import Delivery from "@core/icon/assets/delivery.svg";
export default createSvgComponent(Delivery);